module.exports = __webpack_public_path__ + "static/media/minigame_trash.83916817.svg";